/** dayjs pattern for weekday + zero-padded long date (e.g. Tuesday, July 08, 2026). */
export const LONG_DATE_WITH_WEEKDAY_DAYJS_FORMAT = "dddd, MMMM DD, YYYY";
